import Rollbar from 'rollbar/replay'

const rollbar = new Rollbar({
  accessToken: '047d99b82a1841cb8e48ee8c949ff320',
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: process.env.NODE_ENV,
    client: {
      javascript: {
        code_version: '1.0.0'
      }
    }
  },
  replay: {
    enabled: true,
    maskAllInputs: true
  }
})

export default rollbar
